/**
 * Architecture Translations
 * Loads translations for the Architecture page
 */

import en from './en.json';
import de from './de.json';

// Fallback to English for languages without translations
const translations = {
  en,
  de,
  cs: en,
  da: en,
  el: en,
  es: en,
  fi: en,
  fr: en,
  hu: en,
  id: en,
  it: en,
  nl: en,
  no: en,
  pl: en,
  pt: en,
  ro: en,
  sv: en
};

export default translations;

